import React, { ComponentType } from 'react';
import { useAiEnabled } from './ai-firm-settings-hooks';

/**
 * Higher-Order Component that provides AI enabled state to class components
 *
 * @param WrappedComponent - The component to wrap with AI enabled state
 * @returns A new component with AI enabled state passed as props
 */
export const withAiEnabled = <P extends object>(
  WrappedComponent: ComponentType<
    P & { aiEnabled?: ReturnType<typeof useAiEnabled> }
  >,
) => {
  // Return a functional component
  const WithAiEnabledComponent = (props: P) => {
    // Use the hook to get AI enabled state
    const aiEnabled = useAiEnabled();

    // Pass the AI enabled state as a prop to the wrapped component
    return <WrappedComponent {...props} aiEnabled={aiEnabled} />;
  };

  // Set display name for better debugging
  WithAiEnabledComponent.displayName = `withAiEnabled(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return WithAiEnabledComponent;
};
